export default function CentralSupport(props){
    return <div>CentralSupport</div>
}